import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { ConfirmModal } from '../ui';
import projectService from '../../services/projectService';
import Toast from '../Toast';

const DeleteThreadModal = ({ onClose, refetch, _id }) => {
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const handleSubmit = async () => {
    const payload = {
      project_id: id,
      session_id: _id,
    };
    setLoading(true);
    try {
      const resp = await projectService.deleteProjectSession(payload);
      Toast({ type: 'success', message: resp?.detail });
      refetch?.();
      onClose();
    } catch (error) {
      Toast({ type: 'error', message: error?.detail || 'Something went wrong' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmModal
      title="Delete Thread"
      message="Are you sure you want to delete this thread? This action cannot be undone."
      confirmLabel="Delete"
      busyLabel="Deleting..."
      loading={loading}
      onConfirm={handleSubmit}
      onClose={onClose}
    />
  );
};

export default DeleteThreadModal;
